module.exports = __webpack_public_path__ + "static/media/Futura-Medium.4174065a.ttf";